import React from "react";
import { Grid } from "@mui/material";
import "../styles/Section1.css";
import icon1 from "../assets/Icons/Globe.png";
import icon2 from "../assets/Icons/Scale.png";
import icon3 from "../assets/Icons/Lightning.png";
import icon4 from "../assets/Icons/Money.png";
import DotPattern from "../assets/Images/Dot2.png";

const Features = () => {
  const featureSteps = [
    {
      icon: icon1,
      title: "Secure Savings",
      description:
        "Encrypted transactions ensure your money is safe and only accessible to group members.",
    },
    {
      icon: icon2,
      title: "Transparent Tracking",
      description:
        "Transparent ledger lets all members track the flow of money and ensures accountability.",
    },
    {
      icon: icon3,
      title: "Flexible Plans",
      description:
        "Adjustable contribution settings allow for changes based on group consensus.",
    },
    {
      icon: icon4,
      title: "Automated Distribution",
      description: "Automated, fair distribution of funds with zero hassle.",
    },
  ];

  return (
    <Grid
      container
      spacing={4}
      sx={{
        mt: 0,
        backgroundColor: "#F9FAFB",
        paddingBottom: "60px",
        paddingTop: "30px",
        position: "relative",
        backgroundImage: `url(${DotPattern})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "bottom left",
        backgroundSize: "contain",
        justifyContent: "center",
        alignItems: "center",
      }}
      className="work-se"
    >
      <Grid item sm={10}>
        <Grid container>
          <Grid item sm={5} xs={12}>
            <div className="feature-heading">Features and Benefits</div>
          </Grid>
          <Grid item sm={7} xs={12}>
            <Grid container spacing={4}>
              {featureSteps.map((step, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <div className="f-icon">
                    <img alt="icon" src={step.icon} />
                  </div>
                  <div className="f-lebel">{step.title}</div>
                  <div className="f-text">{step.description}</div>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Features;
